import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DVErrorComponent } from './dverror/dverror.component';
import { DVErrorRefDirective } from './dverror-ref/dverror-ref.directive';
import { DvInputWrapperComponent } from './dv-input-wrapper/dv-input-wrapper.component';
import { FormarrayContainerComponent } from './formarray-container/formarray-container.component';
import { FormarrayDefDirective } from './formarray-def/formarray-def.directive';
import { FormarrayItemComponent } from './formarray-item/formarray-item.component';

@NgModule({
  declarations: [
    DVErrorComponent,
    DVErrorRefDirective,
    DvInputWrapperComponent,
    FormarrayContainerComponent,
    FormarrayDefDirective,
    FormarrayItemComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    DVErrorRefDirective,
    FormarrayDefDirective
  ],
  entryComponents: [
    DVErrorComponent,
    DvInputWrapperComponent,
    FormarrayContainerComponent
  ]
})
export class DynamicValidatorsModule { }
